import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Behöver alla i ledningen göra kunskapsprovet?";
const SHORT_ANSWER = "Minst hälften av personerna i PBI-kretsen med direkt ansvar för serveringen ska ha godkänt prov. Praxis varierar något mellan kommuner.";

export const Route = createFileRoute("/fraga/behover-alla-i-ledningen-gora-provet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Behöver alla i ledningen göra kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Det räcker normalt att tillståndshavaren själv och en eller två serveringsansvariga har godkänt prov. Kommunen avgör vilka som behöver tentera vid större bolag eller komplexa ägarstrukturer."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "PBI-kretsen och kunskapskrav" }}
      related={[{"to": "/fraga/vilka-delar-ingar-i-provet", "label": "Vilka delar ingår i kunskapsprovet?"}, {"to": "/fraga/vad-ar-skillnad-stadigvarande-prov-tillfalligt", "label": "Vad är skillnaden mellan provet för stadigvarande och tillfälligt tillstånd?"}, {"to": "/fraga/far-jag-tolk-pa-provet", "label": "Får jag använda tolk på kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Behöver alla i ledningen göra kunskapsprovet?" },
      { name: "description", content: "Minst hälften av personerna i PBI-kretsen med direkt ansvar för serveringen ska ha godkänt prov. Praxis varierar något mellan kommuner." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/behover-alla-i-ledningen-gora-provet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/behover-alla-i-ledningen-gora-provet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/behover-alla-i-ledningen-gora-provet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Behöver alla i ledningen göra kunskapsprovet", url: "https://alkoholprovet.se/fraga/behover-alla-i-ledningen-gora-provet" },
      ]),
    ],
  }),
});
